import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import { AdProviders, ADUNIT_MAP } from '../constants';
import { useAdUnit } from '../useAdUnit';
const MobileGridDisplayDynamic300x250 = /*#__PURE__*/ React.memo(({ safety ='unlikely' , rowId  })=>{
    const slotAttr = useAdUnit(AdProviders.Nitro, `${ADUNIT_MAP['MobileGridDisplayDynamic300x250']}-${rowId}`, safety, {
        refreshLimit: 30,
        refreshTime: 30,
        renderVisibleOnly: false,
        refreshVisibleOnly: true,
        sizes: [
            [
                '300',
                '250'
            ]
        ],
        report: {
            enabled: false
        }
    });
    return /*#__PURE__*/ React.createElement("div", _extends({}, slotAttr));
}, (last, next)=>{
    return last.safety === next.safety && last.rowId === next.rowId;
});
MobileGridDisplayDynamic300x250.displayName = 'MobileGridDisplayDynamic300x250';
export default MobileGridDisplayDynamic300x250;
